module.exports = __webpack_public_path__ + "vueDist/img/coupon-box.6626194b.png";